import React from 'react'
import { property } from '../../Data/data'

const Category = () => {
   return (
      <div className='p-[1rem] flex flex-wrap bg-[#141414] justify-center item-center gap-[1rem]'>
         {property.map((data, index) => (
            data.link ? <a href={data.link} rel="noopener noreferrer" key={index}
                  className="md:flex-1 w-full bg-[#1A1A1A] transition-all duration-300 ease-in-out hover:bg-[#101010] flex justify-center items-center flex-col gap-[1.5rem] p-[2rem] rounded-md border border-[#262626]"
               >
                  <img src={data.icon} alt="" className='w-[80px] h-[80px]' />
                  <h1 className='font-bold text-[20px] text-gradient'>{data.title}</h1>
               </a> : <div key={index}
                  className="md:flex-1 w-full bg-[#1A1A1A] transition-all duration-300 ease-in-out hover:bg-[#101010] flex justify-center items-center flex-col gap-[1.5rem] p-[2rem] rounded-md border border-[#262626]"
               >
                  <img src={data.icon} alt="" className='w-[80px] h-[80px]' />
                  <h1 className='font-bold text-[20px] text-gradient'>{data.title}</h1>
               </div>
         ))}
            </div>
  )
}

         export default Category
